import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {toggleFeaturesFiltersVisible} from "../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import PricingFiltersBody from "./PricingFiltersBody";
import PricingContext, {usePricingContext} from "../PricingContext";


const PricingFilters = (props) => {

  const {featuresFiltersVisible, toggleFeaturesFiltersVisible, allFilterGroups, theme} = props;

  const {routeParams} = usePricingContext(PricingContext);
  const {paramsGroupName} = routeParams;

  return (
    <aside className={"pr-aside scrollbar3 pr-filters transition2" + (featuresFiltersVisible ? "" : " pr-filters--hidden")}>
      <button onClick={() => toggleFeaturesFiltersVisible(false)}
              className="ui-close ui-close--gray3 ui-close--small"/>
      {featuresFiltersVisible || allFilterGroups.length ? (
        <div className="pl-1 pr-1 pt-2 pb-2 border-box height-100">
          <PricingFiltersBody groupName={paramsGroupName || ""} theme={theme}/>
        </div>
      ) : null}
    </aside>
  )
};

PricingFilters.propTypes = {
  theme: PropTypes.string,
}

const mapStateToProps = (store) => {
  const {featuresFiltersVisible} = store.featuresFiltersState;
  const {featuresListReceived} = store.featuresSetupState;
  const {allFilterGroups} = store.featuresFiltersState;

  return {
    featuresFiltersVisible,
    featuresListReceived,
    allFilterGroups,
  };
};

const mapDispatchToProps = {
  toggleFeaturesFiltersVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFilters);
